import axiosInstance from '../../../config/axiosInstance';
const handleChange = (event, formData, setFormData) => {
    const { name, value } = event.target;
    setFormData({
        ...formData,
        [name]: value,
    });
};

const handleUpdate = async (formData) => {
   try {
        const response = await axiosInstance.post(`/Job/ChangeEngineerTime`, formData);
    } 
    catch (error) {
        console.error('Error posting data:', error);
    }

};

export { handleChange, handleUpdate };